module.exports = __webpack_public_path__ + "static/media/button-check.91ab384d.svg";